<script>
    export let classname = '';
    export let options = [
        { id: 'keyphrases-mode-manual', label: 'Enter keywords manually' },
        { id: 'keyphrases-mode-suggestion', label: 'Select from suggestions' }
    ];
    export let selectedOption = options[0].id;
    export let onOptionChange = (selectedId) => {};

    const handleChange = (event) => {
        selectedOption = event.target.id;
        onOptionChange(selectedOption);
    };
</script>

<div class={classname}>
    <div class="keyphrases_switch btn-group my-1" role="group" aria-label="Keyphrases mode selection">
        {#each options as option}
            <input
                type="radio"
                class="btn-check"
                name="keyphrases-mode"
                id={option.id}
                autocomplete="off"
                checked={selectedOption === option.id}
                on:change={handleChange}
            />
            <label class="btn btn-outline-primary" for={option.id}>{option.label}</label>
        {/each}
    </div>
</div>
